// return 0 - strings are equal, 1 - string a after b, -1 - string a before b
export const compare = (aValue, bValue) => {
  if (aValue === bValue) {
    return 0;
  }

  return aValue > bValue ? 1 : -1;
};
